import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { categories } from "@/mocks/categories";

export default function NewsSidebar() {
  const groups = Array.from(new Set(categories.map((category) => category.group)));

  return (
    <aside className="flex w-full flex-col gap-6">
      <div className="rounded-lg border border-background-300/70 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-links-line text-primary-500" />
          分类导航
        </h3>
        <div className="mt-4 flex flex-col gap-4">
          {groups.map((group) => (
            <div key={group}>
              <p className="text-xs font-medium uppercase tracking-wide text-foreground-400">{group}</p>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {categories
                  .filter((category) => category.group === group)
                  .map((category) => (
                    <Link
                      key={category.key}
                      to={`/category/${category.key}`}
                      className="cursor-pointer rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 transition-colors hover:bg-primary-100 hover:text-primary-700"
                    >
                      {category.name}
                    </Link>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-300/70 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-newspaper-line text-primary-500" />
          最新资讯
        </h3>
        <ul className="mt-4 flex flex-col divide-y divide-background-200">
          {news.map((item) => (
            <li key={item.id} className="py-3.5 first:pt-0 last:pb-0">
              <Link to={`/detail/${item.movieId}`} className="group flex cursor-pointer flex-col gap-1.5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400">{item.date}</span>
                </div>
                <h4 className="font-heading text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{item.summary}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}